<template>
	<div class="partecipants">
	    <div v-if="user.partecipants.length" class="flex flex-col mt-6">
	        <div class="-my-2 overflow-x-auto">
	            <div class="py-2 align-middle inline-block min-w-full">
	                <div class="overflow-hidden border-b border-gray-200 sm:rounded-lg">
	                    <table class="min-w-full divide-y divide-gray-200">
	                        <thead class="bg-gray-50">
	                            <tr>
	                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ $t("Partecipante") }}</th>
	                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ $t("Università") }}</th>
	                                <th scope="col" class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{{ $t("Matricola") }}</th>
	                                <th scope="col" class="relative px-6 py-3">
	                                    <span class="sr-only">{{ $t("Rimuovi") }}</span>
	                                </th>
	                            </tr>
	                        </thead>
	                        <tbody class="bg-white divide-y divide-gray-200">
	                            <tr v-for="p, i in user.partecipants" :key="i">
	                                <td class="px-6 py-4 whitespace-nowrap text-left">
	                                    <div class="text-sm font-medium text-gray-900">
	                                        {{ p.name }} {{ p.surname }}
	                                    </div>
	                                    <div class="text-sm text-gray-500">
	                                        {{ p.email }}
	                                    </div>
	                                </td>
	                                <td class="px-6 py-4 whitespace-nowrap text-left">
	                                    <div class="text-sm text-gray-900">{{ p.school }}</div>
	                                </td>
	                                <td class="px-6 py-4 whitespace-nowrap text-left">
	                                    <span class="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-green-100 text-green-800">
	                                        {{ p.badge }}
	                                    </span>
	                                </td>
	                                <td class="px-6 py-4 whitespace-nowrap text-center text-sm font-medium">
	                                    <a @click="removePartecipant(i)" href="#" class="text-indigo-600 hover:text-indigo-900">{{ $t("Rimuovi") }}</a>
	                                </td>
	                            </tr>
	                            <!-- More people... -->
	                        </tbody>
	                    </table>
	                </div>
	            </div>
	        </div>
	    </div>
	    <div v-if="user.partecipants.length < 2" class="w-full flex flex-wrap bg-white rounded-lg shadow-sm px-2 mt-8 py-10">
	        <div class="w-full sm:w-1/2 text-left px-6">
	            <label class="font-bold">{{ $t("Nome") }}</label>
	            <input type="text" v-model="partecipant.name" class="bg-gray-100 rounded-lg w-full px-4 py-3" :class="{'border border-red-500': $v.partecipant.name.$error}">
	            <span v-if="$v.partecipant.name.$error" class="block text-red-500 text-xs">{{ $t("Required field") }}</span>
	        </div>
	        <div class="w-full sm:w-1/2 text-left px-6 mt-6 sm:mt-0">
	            <label class="font-bold">{{ $t("Cognome") }}</label>
	            <input type="text" v-model="partecipant.surname" class="bg-gray-100 rounded-lg w-full px-4 py-3" :class="{'border border-red-500': $v.partecipant.surname.$error}">
	            <span v-if="$v.partecipant.surname.$error" class="block text-red-500 text-xs">{{ $t("Required field") }}</span>
	        </div>
	        <div class="w-full text-left px-6 mt-6">
	            <label class="font-bold">{{ $t("Indirizzo email") }}</label>
	            <input type="text" v-model="partecipant.email" class="bg-gray-100 rounded-lg w-full px-4 py-3" :class="{'border border-red-500': $v.partecipant.email.$error}">
	            <div v-if="$v.partecipant.email.$error" class="block text-red-500 text-xs ml-4">
	                <div v-if="!$v.partecipant.email.required">{{ $t("Required field") }}</div>
	                <div v-if="!$v.partecipant.email.email">{{ $t("Email address not valid") }}</div>
	            </div>
	        </div>
	        <div class="w-full text-left px-6 mt-6">
	            <label class="font-bold">{{ $t("Nome università") }}</label>
	            <input type="text" v-model="partecipant.school" class="bg-gray-100 rounded-lg w-full px-4 py-3" :class="{'border border-red-500': $v.partecipant.school.$error}">
	            <span v-if="$v.partecipant.school.$error" class="block text-red-500 text-xs">{{ $t("Required field") }}</span>
	        </div>
	        <div class="w-full text-left px-6 mt-6">
	            <label class="font-bold">{{ $t("Numero di matricola universitaria") }}</label>
	            <input type="text" v-model="partecipant.badge" class="bg-gray-100 rounded-lg w-full px-4 py-3" :class="{'border border-red-500': $v.partecipant.badge.$error}">
	            <span v-if="$v.partecipant.badge.$error" class="block text-red-500 text-xs">{{ $t("Required field") }}</span>
	        </div>
	        <div class="w-full text-left px-6 mt-6">
	            <button @click="addPartecipant()" class="rounded-full bg-green-light text-white px-6 py-3 font-semibold text-sm">
	                <svg xmlns="http://www.w3.org/2000/svg" class="h-4 w-4 inline-block mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
	                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
	                </svg>
	                <span>{{ $t("Aggiungi partecipante") }}</span>
	                <loaderIco class="h-5 w-5 text-white ml-2" v-if="loading" />
	            </button>
	        </div>
	    </div>
	</div>
</template>
<script>
import loaderIco from '@/svg/loader.vue'
import { required, minLength, email, sameAs } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import firebase from 'firebase/app'
import "@firebase/auth";
import { db } from '@/db'

export default {
    components: { loaderIco },
    data() {
        return {
            loading: false,
            partecipant: {
                name: null,
                surname: null,
                email: null,
                school: null,
                badge: null
            }
        }
    },
    mounted() {
        this.$v.$reset()
    },
    validations: {
        partecipant: {
            name: {
                required,
            },
            surname: {
                required,
            },
            email: {
                required,
                email
            },
            school: {
                required,
            },
            badge: {
                required,
            }
        }
    },
    computed: {
        ...mapGetters(["user"])
    },
    methods: {
        clearPartecipant() {
            this.partecipant = {
                name: null,
                surname: null,
                email: null,
                school: null,
                badge: null
            }
        },
        async addPartecipant() {
            this.$v.$touch()
            if (this.$v.$invalid) return false

            this.loading = true
            // store user partecipant locally
            this.$store.commit('ADD_PARTECIPANT', this.partecipant)
            // persist user additional data
            await db.collection('users').doc(this.user.id).update({
                partecipants: this.user.partecipants
            })
            this.$v.$reset()
            this.clearPartecipant()
            this.loading = false
        },
        async removePartecipant(index) {
            this.$store.commit('REMOVE_PARTECIPANT', index)            
            // persist user additional data
            await db.collection('users').doc(this.user.id).update({
                partecipants: this.user.partecipants
            })
        }
    }
}
</script>